import { useQuery } from '@tanstack/react-query';
import { getFlashDiscountPeriodTypes } from '../api/get-flash-discount-period-types';

export default function useFlashDiscountPeriodTypes() {
  return useQuery({
    queryKey: ['flash-discount-period-types'],
    queryFn: getFlashDiscountPeriodTypes,

    retry: 2,
    refetchOnWindowFocus: false,
    keepPreviousData: true,

    staleTime: 1000 * 60 * 5, // 5m
    cacheTime: 1000 * 60 * 5, // 5m

    enabled: true,
  });
}
